import React from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import classNames from 'classnames'
import flatten from 'lodash/flatten'
import { Image, InjectHtml } from '@/components/ui'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { LandingBlockContainer } from '..'
import type { IFeatureList } from './interfaces'
import FeatureListGroup from './LandingFeatureListGroup'
import './styles.scss'

export const LandingFeatureList: React.FC<IFeatureList> = props => {
  const { titleId, withFeatureTitles, isLimited, featureGroups, markType, images, blockId } = props
  const { isDesktop } = useDeviceType()

  return (
    <LandingBlockContainer
      titleId={titleId}
      className={classNames('landing-feature-list', {
        'landing-feature-list_limited': isLimited && !images,
        'landing-feature-list_with-images': images,
      })}
      titleClassName="landing-feature-list__title"
      blockId={blockId}
    >
      <div className={images ? 'landing-feature-list-with-images' : ''}>
        {images && (
          <div className="landing-feature-list__images">
            {images.map(({ path, description, link, onActionClick }, index) => (
              <CommonLink key={`${path}_${index}`} url={link} onClick={onActionClick} className="landing-feature-list__image-container">
                <Image src={path} isInStatic className="landing-feature-list__image" />
                {description && <InjectHtml textId={description} TagName="p" className="landing-feature-list__image-description" />}
              </CommonLink>
            ))}
          </div>
        )}
        <div
          className={classNames('landing-feature-list__container', {
            [`landing-feature-list-groups
              landing-feature-list-groups_count-${featureGroups.length}`]: isDesktop,
          })}
        >
          {isDesktop ? (
            featureGroups.map((featureGroup, key) => (
              <FeatureListGroup key={key} features={featureGroup} withFeatureTitles={withFeatureTitles} markType={markType} />
            ))
          ) : (
            <FeatureListGroup features={flatten(featureGroups)} withFeatureTitles={withFeatureTitles} markType={markType} />
          )}
        </div>
      </div>
    </LandingBlockContainer>
  )
}

export default LandingFeatureList
